import { appThemes } from '../env';
import { appStyles } from '../config/appTheme/appTheme';
export const PROJECT_INKASSIER = appThemes.inkassier;
export const PROJECT_INVONED = appThemes.invoned;
export const APP_PROJECT = process.env.MIX_APP_PROJECT;
export const APP_NAME = process.env.MIX_APP_NAME;
if (!APP_PROJECT) {
    throw new Error(`Expected \`process.env.MIX_APP_PROJECT\` to be one of "${PROJECT_INKASSIER}, ${PROJECT_INVONED}", but got "${APP_PROJECT}" instead.`);
}
if (!APP_NAME) {
    throw new Error(`Expected \`process.env.MIX_APP_NAME\` to be truthy, but got "${APP_NAME}" instead.`);
}
export const isProject = (project) => project === getAppThemeName();
export const getAppThemeName = () => APP_PROJECT;
export const getAppTheme = (theme = getAppThemeName()) => {
    return {
        ...appStyles[theme],
    };
};
export const getAppThemesForStorybook = () => {
    const projects = [PROJECT_INKASSIER, PROJECT_INVONED];
    return projects.map(name => ({ ...getAppTheme(name), name }));
};
export const getLogoForTheme = (domain) => domain && domain?.is_vismans && isProject(PROJECT_INKASSIER)
    ? '/img/vismans-logo.png'
    : getAppTheme().logo;
export const getAppName = () => APP_NAME;
